/**
 * @generated SignedSource<<0026db90be559c706fb621f9e46b8a03>>
 * @relayHash 90cd247fc0b7f0e9c2c1da68f6ef4fb4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 402596d4a3bb72a0ce265fd2152f403e2ffb519660078246ade5f4165c133432

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ConfluenceBlogPostStatus = "ARCHIVED" | "CURRENT" | "DELETED" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
export type ConfluenceContentStatus = "ARCHIVED" | "CURRENT" | "DELETED" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
export type ConfluenceContentType = "ATTACHMENT" | "BLOG_POST" | "COMMENT" | "DATABASE" | "EMBED" | "FOLDER" | "PAGE" | "WHITEBOARD" | "%future added value";
export type ConfluencePageStatus = "ARCHIVED" | "CURRENT" | "DELETED" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
export type ConfluencePageSubType = "LIVE" | "%future added value";
export type HomeRecentActivityQuery$variables = {
  after?: string | null | undefined;
  cloudId: string;
  eventTypes?: ReadonlyArray<string> | null | undefined;
  first?: number | null | undefined;
  objectTypes?: ReadonlyArray<string> | null | undefined;
};
export type HomeRecentActivityQuery$data = {
  readonly activity: {
    readonly myActivity: {
      readonly all: {
        readonly edges: ReadonlyArray<{
          readonly cursor: string;
          readonly node: {
            readonly event: {
              readonly eventType: string;
              readonly id: string;
              readonly timestamp: AGG$DateTime;
            };
            readonly id: string;
            readonly object: {
              readonly data: {
                readonly blogStatus?: ConfluenceBlogPostStatus | null | undefined;
                readonly body?: {
                  readonly excerpt: string | null | undefined;
                } | null | undefined;
                readonly commentCountSummary?: {
                  readonly total: number | null | undefined;
                } | null | undefined;
                readonly commentId?: string | null | undefined;
                readonly container?: {
                  readonly blogStatus?: ConfluenceBlogPostStatus | null | undefined;
                  readonly body?: {
                    readonly excerpt: string | null | undefined;
                  } | null | undefined;
                  readonly commentCountSummary?: {
                    readonly total: number | null | undefined;
                  } | null | undefined;
                  readonly createdAt?: string | null | undefined;
                  readonly editorVersion?: ReadonlyArray<{
                    readonly value: string;
                  } | null | undefined> | null | undefined;
                  readonly id?: string;
                  readonly likesSummary?: {
                    readonly count: number | null | undefined;
                  } | null | undefined;
                  readonly links?: {
                    readonly editUi: string | null | undefined;
                    readonly webUi: string | null | undefined;
                  } | null | undefined;
                  readonly metadata?: {
                    readonly titleEmojiDraft: {
                      readonly value: string | null | undefined;
                    } | null | undefined;
                    readonly titleEmojiPublished: {
                      readonly value: string | null | undefined;
                    } | null | undefined;
                  } | null | undefined;
                  readonly pageStatus?: ConfluencePageStatus | null | undefined;
                  readonly space?: {
                    readonly alias: string | null | undefined;
                    readonly id: string;
                    readonly key: string | null | undefined;
                    readonly name: string | null | undefined;
                  } | null | undefined;
                  readonly status?: ConfluenceContentStatus | null | undefined;
                  readonly subtype?: ConfluencePageSubType | null | undefined;
                  readonly title?: string | null | undefined;
                  readonly type?: ConfluenceContentType | null | undefined;
                  readonly viewer?: {
                    readonly favoritedSummary: {
                      readonly isFavorite: boolean;
                    } | null | undefined;
                  } | null | undefined;
                } | null | undefined;
                readonly createdAt?: string | null | undefined;
                readonly editorVersion?: ReadonlyArray<{
                  readonly value: string;
                } | null | undefined> | null | undefined;
                readonly id?: string;
                readonly likesSummary?: {
                  readonly count: number | null | undefined;
                } | null | undefined;
                readonly links?: {
                  readonly editUi: string | null | undefined;
                  readonly webUi: string | null | undefined;
                } | null | undefined;
                readonly metadata?: {
                  readonly titleEmojiDraft: {
                    readonly value: string | null | undefined;
                  } | null | undefined;
                  readonly titleEmojiPublished: {
                    readonly value: string | null | undefined;
                  } | null | undefined;
                } | null | undefined;
                readonly pageStatus?: ConfluencePageStatus | null | undefined;
                readonly space?: {
                  readonly alias: string | null | undefined;
                  readonly id: string;
                  readonly key: string | null | undefined;
                  readonly name: string | null | undefined;
                } | null | undefined;
                readonly status?: ConfluenceContentStatus | null | undefined;
                readonly subtype?: ConfluencePageSubType | null | undefined;
                readonly title?: string | null | undefined;
                readonly type?: ConfluenceContentType | null | undefined;
                readonly viewer?: {
                  readonly favoritedSummary: {
                    readonly isFavorite: boolean;
                  } | null | undefined;
                } | null | undefined;
              } | null | undefined;
              readonly id: string;
            };
          };
        }>;
        readonly pageInfo: {
          readonly endCursor: string | null | undefined;
          readonly hasNextPage: boolean;
        };
      };
    } | null | undefined;
  } | null | undefined;
};
export type HomeRecentActivityQuery = {
  response: HomeRecentActivityQuery$data;
  variables: HomeRecentActivityQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "eventTypes"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "objectTypes"
},
v5 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "fields": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "eventTypes",
            "variableName": "eventTypes"
          },
          {
            "kind": "Variable",
            "name": "objectTypes",
            "variableName": "objectTypes"
          },
          {
            "kind": "Literal",
            "name": "products",
            "value": [
              "CONFLUENCE"
            ]
          }
        ],
        "kind": "ObjectValue",
        "name": "arguments"
      },
      {
        "items": [
          {
            "kind": "Variable",
            "name": "rootContainerIds.0",
            "variableName": "cloudId"
          }
        ],
        "kind": "ListValue",
        "name": "rootContainerIds"
      },
      {
        "kind": "Literal",
        "name": "type",
        "value": "AND"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ScalarField",
  "name": "title"
},
v9 = {
  "kind": "ScalarField",
  "name": "type"
},
v10 = {
  "kind": "ScalarField",
  "name": "subtype"
},
v11 = {
  "alias": "pageStatus",
  "kind": "ScalarField",
  "name": "status"
},
v12 = {
  "kind": "ScalarField",
  "name": "createdAt"
},
v13 = {
  "kind": "ScalarField",
  "name": "webUi"
},
v14 = [
  (v13/*: any*/),
  {
    "kind": "ScalarField",
    "name": "editUi"
  }
],
v15 = {
  "concreteType": "ConfluencePageLinks",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": (v14/*: any*/)
},
v16 = {
  "concreteType": "ConfluenceBodies",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "excerpt"
    }
  ]
},
v17 = [
  {
    "concreteType": "ConfluenceFavoritedSummary",
    "kind": "LinkedField",
    "name": "favoritedSummary",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "isFavorite"
      }
    ]
  }
],
v18 = {
  "concreteType": "ConfluencePageViewerSummary",
  "kind": "LinkedField",
  "name": "viewer",
  "plural": false,
  "selections": (v17/*: any*/)
},
v19 = {
  "concreteType": "ConfluenceCommentCountSummary",
  "kind": "LinkedField",
  "name": "commentCountSummary",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "total"
    }
  ]
},
v20 = {
  "concreteType": "ConfluenceSpace",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "kind": "ScalarField",
      "name": "alias"
    },
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    }
  ]
},
v21 = {
  "concreteType": "ConfluenceLikesSummary",
  "kind": "LinkedField",
  "name": "likesSummary",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "count"
    }
  ]
},
v22 = [
  {
    "kind": "Literal",
    "name": "keys",
    "value": [
      "editor"
    ]
  }
],
v23 = {
  "kind": "ScalarField",
  "name": "value"
},
v24 = [
  (v23/*: any*/)
],
v25 = {
  "concreteType": "ConfluenceContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "concreteType": "ConfluenceContentTitleEmoji",
      "kind": "LinkedField",
      "name": "titleEmojiDraft",
      "plural": false,
      "selections": (v24/*: any*/)
    },
    {
      "concreteType": "ConfluenceContentTitleEmoji",
      "kind": "LinkedField",
      "name": "titleEmojiPublished",
      "plural": false,
      "selections": (v24/*: any*/)
    }
  ]
},
v26 = {
  "kind": "InlineFragment",
  "selections": [
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/),
    (v15/*: any*/),
    (v16/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/),
    (v20/*: any*/),
    (v21/*: any*/),
    {
      "alias": "editorVersion",
      "args": (v22/*: any*/),
      "concreteType": "ConfluencePageProperty",
      "kind": "LinkedField",
      "name": "properties",
      "plural": true,
      "selections": (v24/*: any*/),
      "storageKey": "properties(keys:[\"editor\"])"
    },
    (v25/*: any*/)
  ],
  "type": "ConfluencePage"
},
v27 = {
  "alias": "blogStatus",
  "kind": "ScalarField",
  "name": "status"
},
v28 = {
  "concreteType": "ConfluenceBlogPostLinks",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": (v14/*: any*/)
},
v29 = {
  "concreteType": "ConfluenceBlogPostViewerSummary",
  "kind": "LinkedField",
  "name": "viewer",
  "plural": false,
  "selections": (v17/*: any*/)
},
v30 = {
  "alias": "editorVersion",
  "args": (v22/*: any*/),
  "concreteType": "ConfluenceBlogPostProperty",
  "kind": "LinkedField",
  "name": "properties",
  "plural": true,
  "selections": (v24/*: any*/),
  "storageKey": "properties(keys:[\"editor\"])"
},
v31 = {
  "kind": "ScalarField",
  "name": "status"
},
v32 = [
  (v13/*: any*/)
],
v33 = {
  "concreteType": "ConfluenceContentViewerSummary",
  "kind": "LinkedField",
  "name": "viewer",
  "plural": false,
  "selections": (v17/*: any*/)
},
v34 = {
  "kind": "InlineFragment",
  "selections": [
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v31/*: any*/),
    {
      "concreteType": "ConfluenceWhiteboardLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v32/*: any*/)
    },
    (v33/*: any*/),
    (v19/*: any*/),
    (v20/*: any*/)
  ],
  "type": "ConfluenceWhiteboard"
},
v35 = {
  "kind": "InlineFragment",
  "selections": [
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v31/*: any*/),
    {
      "concreteType": "ConfluenceDatabaseLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v32/*: any*/)
    },
    (v33/*: any*/),
    (v19/*: any*/),
    (v20/*: any*/)
  ],
  "type": "ConfluenceDatabase"
},
v36 = {
  "kind": "InlineFragment",
  "selections": [
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v31/*: any*/),
    {
      "concreteType": "ConfluenceEmbedLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v32/*: any*/)
    },
    (v33/*: any*/),
    (v19/*: any*/),
    (v20/*: any*/),
    (v25/*: any*/)
  ],
  "type": "ConfluenceEmbed"
},
v37 = {
  "kind": "ScalarField",
  "name": "commentId"
},
v38 = [
  (v7/*: any*/),
  (v37/*: any*/),
  {
    "kind": "LinkedField",
    "name": "container",
    "plural": false,
    "selections": [
      (v26/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v27/*: any*/),
          (v28/*: any*/),
          (v16/*: any*/),
          (v29/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v30/*: any*/),
          (v25/*: any*/)
        ],
        "type": "ConfluenceBlogPost"
      },
      (v34/*: any*/)
    ]
  }
],
v39 = {
  "concreteType": "ActivityEvent",
  "kind": "LinkedField",
  "name": "event",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "kind": "ScalarField",
      "name": "timestamp"
    },
    {
      "kind": "ScalarField",
      "name": "eventType"
    }
  ]
},
v40 = {
  "concreteType": "ActivityPageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    },
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v41 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v42 = [
  (v23/*: any*/),
  (v7/*: any*/)
],
v43 = {
  "kind": "InlineFragment",
  "selections": [
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/),
    (v15/*: any*/),
    (v16/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/),
    (v20/*: any*/),
    (v21/*: any*/),
    {
      "alias": "editorVersion",
      "args": (v22/*: any*/),
      "concreteType": "ConfluencePageProperty",
      "kind": "LinkedField",
      "name": "properties",
      "plural": true,
      "selections": (v42/*: any*/),
      "storageKey": "properties(keys:[\"editor\"])"
    },
    (v25/*: any*/)
  ],
  "type": "ConfluencePage"
},
v44 = {
  "alias": "editorVersion",
  "args": (v22/*: any*/),
  "concreteType": "ConfluenceBlogPostProperty",
  "kind": "LinkedField",
  "name": "properties",
  "plural": true,
  "selections": (v42/*: any*/),
  "storageKey": "properties(keys:[\"editor\"])"
},
v45 = [
  (v7/*: any*/)
],
v46 = {
  "kind": "InlineFragment",
  "selections": (v45/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v47 = [
  (v7/*: any*/),
  (v37/*: any*/),
  {
    "kind": "LinkedField",
    "name": "container",
    "plural": false,
    "selections": [
      (v41/*: any*/),
      (v43/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v27/*: any*/),
          (v28/*: any*/),
          (v16/*: any*/),
          (v29/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v44/*: any*/),
          (v25/*: any*/)
        ],
        "type": "ConfluenceBlogPost"
      },
      (v34/*: any*/),
      (v46/*: any*/)
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "HomeRecentActivityQuery",
    "selections": [
      {
        "concreteType": "Activity",
        "kind": "LinkedField",
        "name": "activity",
        "plural": false,
        "selections": [
          {
            "concreteType": "MyActivity",
            "kind": "LinkedField",
            "name": "myActivity",
            "plural": false,
            "selections": [
              {
                "args": (v5/*: any*/),
                "concreteType": "ActivityConnection",
                "kind": "LinkedField",
                "name": "all",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ActivityItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "concreteType": "ActivityNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "concreteType": "ActivityObject",
                            "kind": "LinkedField",
                            "name": "object",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "data",
                                "plural": false,
                                "selections": [
                                  (v26/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v7/*: any*/),
                                      (v8/*: any*/),
                                      (v9/*: any*/),
                                      (v27/*: any*/),
                                      (v12/*: any*/),
                                      (v28/*: any*/),
                                      (v16/*: any*/),
                                      (v29/*: any*/),
                                      (v19/*: any*/),
                                      (v20/*: any*/),
                                      (v21/*: any*/),
                                      (v30/*: any*/),
                                      (v25/*: any*/)
                                    ],
                                    "type": "ConfluenceBlogPost"
                                  },
                                  (v34/*: any*/),
                                  (v35/*: any*/),
                                  (v36/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v38/*: any*/),
                                    "type": "ConfluenceInlineComment"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v38/*: any*/),
                                    "type": "ConfluenceFooterComment"
                                  }
                                ]
                              }
                            ]
                          },
                          (v39/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v40/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "HomeRecentActivityQuery",
    "selections": [
      {
        "concreteType": "Activity",
        "kind": "LinkedField",
        "name": "activity",
        "plural": false,
        "selections": [
          {
            "concreteType": "MyActivity",
            "kind": "LinkedField",
            "name": "myActivity",
            "plural": false,
            "selections": [
              {
                "args": (v5/*: any*/),
                "concreteType": "ActivityConnection",
                "kind": "LinkedField",
                "name": "all",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ActivityItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "concreteType": "ActivityNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "concreteType": "ActivityObject",
                            "kind": "LinkedField",
                            "name": "object",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "data",
                                "plural": false,
                                "selections": [
                                  (v41/*: any*/),
                                  (v43/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v7/*: any*/),
                                      (v8/*: any*/),
                                      (v9/*: any*/),
                                      (v27/*: any*/),
                                      (v12/*: any*/),
                                      (v28/*: any*/),
                                      (v16/*: any*/),
                                      (v29/*: any*/),
                                      (v19/*: any*/),
                                      (v20/*: any*/),
                                      (v21/*: any*/),
                                      (v44/*: any*/),
                                      (v25/*: any*/)
                                    ],
                                    "type": "ConfluenceBlogPost"
                                  },
                                  (v34/*: any*/),
                                  (v35/*: any*/),
                                  (v36/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v47/*: any*/),
                                    "type": "ConfluenceInlineComment"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v47/*: any*/),
                                    "type": "ConfluenceFooterComment"
                                  },
                                  (v46/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v45/*: any*/),
                                    "type": "DevOpsPullRequestDetails"
                                  }
                                ]
                              }
                            ]
                          },
                          (v39/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v40/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "90cd247fc0b7f0e9c2c1da68f6ef4fb4",
    "id": "402596d4a3bb72a0ce265fd2152f403e2ffb519660078246ade5f4165c133432",
    "metadata": {},
    "name": "HomeRecentActivityQuery",
    "operationKind": "query",
    "text": "query HomeRecentActivityQuery($cloudId:ID!,$first:Int,$after:String,$eventTypes:[String!],$objectTypes:[String!]){activity{myActivity{all(filter:{type:AND,rootContainerIds:[$cloudId],arguments:{products:[\"CONFLUENCE\"],objectTypes:$objectTypes,eventTypes:$eventTypes}},first:$first,after:$after){edges{cursor,node{id,object{id,data{__typename,...on ConfluencePage{id,title,type,subtype,pageStatus:status,createdAt,links{webUi,editUi},body{excerpt},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},likesSummary{count},editorVersion:properties(keys:[\"editor\"]){value,id},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceBlogPost{id,title,type,blogStatus:status,createdAt,links{webUi,editUi},body{excerpt},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},likesSummary{count},editorVersion:properties(keys:[\"editor\"]){value,id},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceWhiteboard{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name}},...on ConfluenceDatabase{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name}},...on ConfluenceEmbed{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceInlineComment{id,commentId,container{__typename,...on ConfluencePage{id,title,type,subtype,pageStatus:status,createdAt,links{webUi,editUi},body{excerpt},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},likesSummary{count},editorVersion:properties(keys:[\"editor\"]){value,id},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceBlogPost{id,title,type,blogStatus:status,links{webUi,editUi},body{excerpt},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},editorVersion:properties(keys:[\"editor\"]){value,id},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceWhiteboard{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name}},...on Node{__isNode:__typename,id}}},...on ConfluenceFooterComment{id,commentId,container{__typename,...on ConfluencePage{id,title,type,subtype,pageStatus:status,createdAt,links{webUi,editUi},body{excerpt},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},likesSummary{count},editorVersion:properties(keys:[\"editor\"]){value,id},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceBlogPost{id,title,type,blogStatus:status,links{webUi,editUi},body{excerpt},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},editorVersion:properties(keys:[\"editor\"]){value,id},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceWhiteboard{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name}},...on Node{__isNode:__typename,id}}},...on Node{__isNode:__typename,id},...on DevOpsPullRequestDetails{id}}},event{id,timestamp,eventType}}},pageInfo{hasNextPage,endCursor}}}}}"
  }
};
})();

(node as any).hash = "52341ed87e0393b64ab0d4467f335784";

export default node;
